import { ButtonV2 } from '@cimplico/components';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { useIntercom } from 'react-use-intercom';
import { toastNotification } from '../../../../../components/toast/Toast';
import { intercomEvents } from '../../../../../intercom-events';
import { useWorkpaperContext } from '../../../../../providers/WorkpaperProvider';
import { useSyncExternalTrialBalance } from '../../../../../queries/use-trial-balance';

type RefreshXeroAccountProps = {
    onXeroAuthError?: () => void;
};

function RefreshXeroAccount({ onXeroAuthError }: RefreshXeroAccountProps): JSX.Element {
    const workpaper = useWorkpaperContext();
    const refreshQuery = useSyncExternalTrialBalance(workpaper.id);
    const { trackEvent } = useIntercom();

    function refresh(): void {
        // Send to intercom
        trackEvent(intercomEvents.trialBalance.accountRefresh.event, intercomEvents.trialBalance.accountRefresh.metaData(workpaper));

        refreshQuery.mutate(undefined, {
            onError: (err) => {
                const error = err.response?.data;
                if (error && 'type' in error && error.type === 'IntegrationError') {
                    onXeroAuthError && onXeroAuthError();
                }

                toastNotification('error', 'Unable to refresh account.');
            },
        });
    }

    return (
        <div>
            <ButtonV2
                label="Refresh"
                type="hollow"
                leftIcon={<ArrowPathIcon />}
                size="sm"
                onClick={refresh}
                isDisabled={refreshQuery.isLoading}
                isLoading={refreshQuery.isLoading}
            />
        </div>
    );
}

export default RefreshXeroAccount;
